import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  constructor(
    private router: Router,
    public authService: AuthService
  ) {}

  isAuthenticated(): boolean {
    const auth = localStorage.getItem('auth');
    return !!auth && JSON.parse(auth).authToken;
  }

  goBack(): void {
    if (this.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/auth/login']);
    }
  }
} 